import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastyService } from 'ng2-toasty';
import { Interaction } from 'src/app/pages/interactions/interaction.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quadrato-magico',
  templateUrl: './quadrato-magico.component.html',
  styleUrls: ['./quadrato-magico.component.scss']
})
export class QuadratoMagicoComponent implements OnInit {

  @Input() interaction: Interaction;
  @Output() addInteraction = new EventEmitter();

  quadratoMagicoForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    subtitle: new FormControl('',),
    info: new FormControl(''),
    lat: new FormControl(''),
    lng: new FormControl(''),
    image: new FormControl(null, [Validators.required]),
  });

  constructor(
    private toastyService: ToastyService
  ) { }

  ngOnInit(): void {
    if (this.interaction) { // devo riempire i field
      this.populateForm();
    } else {
      this.interaction = {interactionType: 'quadratoMagico'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.quadratoMagicoForm.controls;
  }

  populateForm(): void {
    this.f.title.setValue(this.interaction.title);
    this.f.subtitle.setValue(this.interaction.subtitle);
    this.interaction.interactionData && this.interaction.interactionData.info ? this.f.info.setValue(this.interaction.interactionData.info) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lat.setValue(this.interaction.interactionData.coordinates.lat) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lng.setValue(this.interaction.interactionData.coordinates.lng) : '';
    this.f.image.setValue(this.interaction.image);
  }

  setImageUrl(event): void {
    if (event) {
          this.f.image.setValue(event.filename);
          this.interaction.image = event.filename;
    } else {
      this.f.image.setValue(null);
      this.interaction.image = null;
    }
  }

  validateTitle(): boolean {
    return !this.f.title.errors && !this.f.subtitle.errors;
  }

  setTitle(): void {
    this.interaction.title = this.f.title.value;
    this.interaction.subtitle = this.f.subtitle.value;
  }

  onAddInteraction(): void {
    this.interaction.interactionData = {
      info: this.f.info.value,
      coordinates: {
        lat: this.f.lat.value,
        lng: this.f.lng.value
      }
    };
    this.addInteraction.emit(this.interaction);
  }

}
